import React, { useState } from "react";
import Select from "react-select";
import { FlagIcon } from "react-flag-kit";

const countryOptions = [
  { value: "+65", label: "Singapore", code: "SG" },
  { value: "+1", label: "USA", code: "US" },
  { value: "+91", label: "India", code: "IN" },
];

  const countries = [
    { code: 'SG', label: 'Singapore', value: '+65' },
    { code: 'US', label: 'United States', value: '+1' },
    { code: 'GB', label: 'United Kingdom', value: '+44' },
    { code: 'CA', label: 'Canada', value: '+1'},
    { code: 'AU', label: 'Australia', value: '+61' },
    { code: 'DE', label: 'Germany', value: '+49' },
    { code: 'FR', label: 'France', value: '+33' },
    { code: 'IT', label: 'Italy', value: '+39' },
    { code: 'ES', label: 'Spain', value: '+34' },
    { code: 'JP', label: 'Japan', value: '+81'},
    { code: 'KR', label: 'South Korea', value: '+82' },
    { code: 'CN', label: 'China', value: '+86' },
    { code: 'IN', label: 'India', value: '+91' },    
    { code: 'MY', label: 'Malaysia', value: '+60' },
    { code: 'TH', label: 'Thailand', value: '+66' },
    { code: 'BR', label: 'Brazil', value: '+55' },
    { code: 'MX', label: 'Mexico', value: '+52' },
    { code: 'RU', label: 'Russia', value: '+7'},
    { code: 'ZA', label: 'South Africa', value: '+27'},
    { code: 'NG', label: 'Nigeria', value: '+234' }
  ];

export default function PhoneInput() {
  const [country, setCountry] = useState(countries[0]);
  const [phone, setPhone] = useState("");

  const customOption = (props) => (
    <div className="flex items-center gap-2">
      <FlagIcon code={props.data.code} size={16} />
      <span>{props.data.value}</span>
    </div>
  );

   const handlePhoneChange = (e) => {
    const value = e.target.value;
    if (/^\d*$/.test(value)) {
      setPhone(value);
    }
  };

  return (
    <div className="flex items-center gap-2 p-2 rounded-md w-full ">
      <div className="w-32">
        <Select
          
          name="area"
          options={countries}
          value={country}
          onChange={setCountry}
          formatOptionLabel={(option) => (
            <div className="flex items-center gap-2">
              <FlagIcon code={option.code} size={16} />
              <span>{option.value}</span>
            </div>
          )}
        />
      </div>
      <input
        name="phone"
        type="text"
        placeholder="Enter phone number"
        value={phone}
        onChange={handlePhoneChange}
        className="flex-1 p-2  bg-gray-50 focus:outline-none "
        
      />
      <input type="hidden" id="userId" name="phone_code" value={country["value"]}></input>
    </div>
  );
}
